<div class="c-plus l-container u-margin-top-xl">

  <!-- Logged-in identity -->
  <div class="c-plus__profile">
    <i class="c-plus__avatar fa-solid fa-circle-user" aria-hidden="true"></i>
    <div class="c-plus__id">
      <span class="c-plus__name">{{ userContext.getDisplayName() | titlecase }}</span>
      <span class="c-plus__num">{{ userContext.getUserIdentifier() }}</span>
    </div>
  </div>

  <!-- Internal-only: member search -->
  @if (userContext.isInternalUser()) {
    <a class="c-plus__row" routerLink="/search" routerLinkActive="is-active">
      <i class="c-plus__icon fa-solid fa-magnifying-glass" aria-hidden="true"></i>
      <span class="c-plus__label">{{ 'MENU.search_member' | translate }}</span>
      <i class="c-plus__chev fa-solid fa-chevron-right" aria-hidden="true"></i>
    </a>
  }

  <!-- All rubrics (launcher grid) -->
  <myabvv-home-grid></myabvv-home-grid>

  <!-- Account actions -->
  <div class="c-plus__account">
    <button class="c-plus__row" type="button" (click)="toggleDarkMode()">
      <i class="c-plus__icon pi" [class.pi-sun]="theme.darkMode()" [class.pi-moon]="!theme.darkMode()" aria-hidden="true"></i>
      <span class="c-plus__label">{{ 'MENU.theme' | translate }}</span>
    </button>
    <button class="c-plus__row c-plus__logout" type="button" (click)="logout()">
      <i class="c-plus__icon fa-solid fa-right-from-bracket" aria-hidden="true"></i>
      <span class="c-plus__label">{{ 'AUTH.LOGOUT' | translate }}</span>
    </button>
  </div>

</div>
